export const STRIPE_FRAME_ID = 'stripe-hosted-fields-frame';
export const FRAME_HEIGHT = 255;
